<template>
  <div class="z1">
    <footer>
      <div class="container-fluid">
        <div class="row d-flex justify-content-center align-items-center pt-3">
          <div class="col-12 text-center">
            <p class="blanco fG2 py-3 bold">
              CONTÁCTANOS
            </p>

            <p class="blanco fG pb-3 bold">
              <a href="mailto:info@arreglalo.com.mx">info@arreglalo.com.mx</a>
            </p>
            <p class="blanco fG pb-3 bold">
              <a href="https://www.arreglalo.com.mx/franquicias">https://www.arreglalo.com.mx/franquicias</a>
            </p>
            <p class="pb-5 rrss">
              <span>
                <a class="facebooklink" href="#">
                  <img class="img-fluid" src="../assets/imgs/arreglalo/ico_fb.svg" alt="Facebook Arréglalo">
                </a>
              </span>
              <span>
                <a class="twitterlink" href="#">
                  <img class="img-fluid" src="../assets/imgs/arreglalo/ico_twt.svg" alt="Twitter Arréglalo">
                </a>
              </span>
            </p>
          </div>

          
        </div>
      </div>
    </footer>

   

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

